import { PageLink, PageTitle } from "_metronic/layout/core";
import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import { useParams } from "react-router-dom";
import ServiceChargeInvoicingDetails from "./components/ServiceChargeInvoicingDetails";

const ServiceChargeInvoiceDetailsPage = () => {
  const { logIDParam } = useParams();

  let logID;
  if (logIDParam) {
    const parsedLogID = parseInt(logIDParam, 10);
    if (parsedLogID > 0) {
      logID = parsedLogID;
    }
  }

  const serviceChargeInvoiceBreadCrumbs: Array<PageLink> = [
    {
      title: "Service Charge Summaries",
      path: "/ServiceChargeInvoicing",
      isSeparator: false,
      isActive: false,
    },
    {
      title: "",
      path: "",
      isSeparator: true,
      isActive: false,
    },
    {
      title: "Service Charge Details",
      path: "/Details/" + logID,
      isSeparator: false,
      isActive: true,
    },
  ];

  if (logID == undefined) {
    return <></>;
  }

  return (
    <CPLAnalytics pageName="Service Charge Invoice Details">
      <PageTitle breadcrumbs={serviceChargeInvoiceBreadCrumbs}></PageTitle>
      <ServiceChargeInvoicingDetails logID={logID} />
    </CPLAnalytics>
  );
};

export default ServiceChargeInvoiceDetailsPage;
